import { ControllerParams } from '@wix/yoshi-flow-editor';
import { getApiBaseUrl } from './index';
import { VIDEO_APP_DEF_ID } from '@wix/wix-vod-constants/dist/common/app-def-id';
import { setInstance } from '../../configure-client';
import { createMemoryHistory } from 'history';
import { setHydratedDataFromSource } from '../../redux/hydrated-data/hydrated-data';
import { setInitialAppSettings } from '../../redux/actions/app-settings';
import { ControllerState, Handlers } from '../controller-handlers';
import { updateControllerState } from '../../redux/actions/controller-state';
import { HydratedSource } from './get-hydrated-source';

export interface InitialData extends HydratedSource {
  currentPageId?: string;
}

export async function createStore(
  getStoreBuilder: Function,
  controllerConfig: ControllerParams['controllerConfig'],
  initialData: InitialData,
  setProps: (props: { [key: string]: any }) => void,
  debug: boolean,
  isSSR: boolean,
  isMobile: boolean,
  handlers: Handlers,
  getControllerState: () => ControllerState,
) {
  const { wixCodeApi } = controllerConfig;
  const baseUrl = getApiBaseUrl(wixCodeApi);
  const url = '/';
  const { instance } = initialData;
  const configData = { instance, url, baseUrl };

  const onInstanceChanged = (event: { instance: string }) => {
    const newConfigData = { ...configData, instance: event.instance };
    setInstance(event.instance);
    setProps({ configData: newConfigData });
  };

  wixCodeApi.site.onInstanceChanged(onInstanceChanged, VIDEO_APP_DEF_ID);

  const history = createMemoryHistory({ initialEntries: [url] });

  const { createStore: origCreateStore, setInitialState } =
    getStoreBuilder(isMobile);

  const store = origCreateStore({
    history,
    debug,
    isSSR,
    handlers,
  });
  setInstance(configData.instance);

  store.dispatch(setHydratedDataFromSource(initialData));
  store.dispatch(setInitialAppSettings(initialData.appSettings));

  if (setInitialState) {
    await store.dispatch(setInitialState());
  }

  const controllerState = getControllerState();

  if (controllerState) {
    store.dispatch(updateControllerState(getControllerState()));
  }

  return {
    configData,
    appState: store.getState(),
  };
}
